import { VariationFe } from "@intelligems/ig-types/fe-only/variations";
import { applyPriceTransform } from "@intelligems/ig-utils/experience-products/applyPriceTransform";
import { getPriceTransformFromVariation } from "@intelligems/ig-utils/experience-products/getPriceTransformFromVariation";

export function getPriceFromProductVariant(
  group: VariationFe,
  value: string | undefined
): string | null {
  if (value) {
    const transform = getPriceTransformFromVariation(group);
    if (transform) {
      return applyPriceTransform(value, transform)?.toFixed(2) ?? null;
    }
    if (group.isControl) {
      return value;
    }
  }
  return null;
}
